import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../LanguageContext";

const TOOL_KEYS = [
  { to: "/remote-timer", ns: "businessTools.timer",    directUrl: "https://myremotetimer.steuernagel.net", icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg> },
  { to: "/fastvote",     ns: "businessTools.fastvote", directUrl: "https://fastvote.steuernagel.net",       icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg> },
  { to: "/qrcode",       ns: "businessTools.qrcode",   icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="4" height="4"/></svg> },
  { to: "/repayment",    ns: "businessTools.repayment", icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg> },
];

function Timer() {
  const { t } = useLang();

  return (
    <div className="timer-page">
      <div className="page-section-header">
        <span className="section-label">{t("businessTools.label")}</span>
        <div className="subhead">{t("businessTools.title")}</div>
        {t("businessTools.intro").map((p, i) => (
          <p key={i} className="section-intro-inner">{p}</p>
        ))}
      </div>

      <div className="tool-cards">
        {TOOL_KEYS.map(({ to, ns, icon, directUrl }) => (
          <Link key={to} to={to} className="tool-card tool-card-link">
            <div className="tool-icon">{icon}</div>
            <h3>{t(`${ns}.title`)}</h3>
            <p>{t(`${ns}.desc`)}</p>
            <span className="tool-tag">{t(`${ns}.tag`)}</span>
            {directUrl && (
              <a
                href={directUrl}
                target="_blank"
                rel="noreferrer"
                className="tool-direct-link"
                onClick={(e) => e.stopPropagation()}
              >
                {t("businessTools.directLink")}
              </a>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Timer;
